<div nz-row nzJustify="space-between" class="topbar">
	<div nz-col></div>

	<div nz-col>
		<nz-space [nzSize]="size">
			<nz-space-item>
		<!--<div class="mb-0 mr-auto d-xl-block d-none">-->
				<app-topbar-project-management></app-topbar-project-management>
			</nz-space-item>
			<nz-space-item>
		<!--<div class="mr-4 d-none d-sm-block">-->
			<app-topbar-language-switcher></app-topbar-language-switcher>
			</nz-space-item>
			<nz-space-item>
				<app-topbar-user-menu></app-topbar-user-menu>
			</nz-space-item>
		</nz-space>
	</div>
</div>
